import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { trainingApi, Training as TrainingType } from '../services/api';
import DispoContent from '../components/dispo/DispoContent';
import '../styles/Training.css';

export function Training() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  const [training, setTraining] = useState<TrainingType | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadTraining = async () => {
      if (!slug) {
        setError('Keine Schulung angegeben');
        setIsLoading(false);
        return;
      }

      try {
        const response = await trainingApi.getBySlug(slug);
        if (response.success && response.training) {
          setTraining(response.training);
        }
      } catch (err: unknown) {
        const error = err as Error & { status?: number };
        if (error.status === 404) {
          setError('Schulung nicht gefunden');
        } else {
          setError(error.message || 'Fehler beim Laden der Schulung');
        }
      } finally {
        setIsLoading(false);
      }
    };

    loadTraining();
  }, [slug]);

  if (isLoading) {
    return (
      <div className="training-loading">
        <div className="loading-spinner"></div>
        <p>Schulung wird geladen...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="training-error">
        <p>{error}</p>
        <button onClick={() => navigate('/dashboard')}>Zurueck zum Dashboard</button>
      </div>
    );
  }

  if (!training) {
    return (
      <div className="training-error">
        <p>Schulung nicht gefunden</p>
        <button onClick={() => navigate('/dashboard')}>Zurueck zum Dashboard</button>
      </div>
    );
  }

  return (
    <div className="training-page">
      <div className="training-header" style={{ backgroundColor: training.color }}>
        <button className="back-btn" onClick={() => navigate('/dashboard')}>
          &larr; Zurueck
        </button>
        <h1>{training.name}</h1>
        <p>{training.description}</p>
      </div>

      <div className="training-content">
        {slug === 'dispo' && <DispoContent />}
        {slug !== 'dispo' && (
          <div className="training-placeholder">
            <p>Inhalte fuer "{training.name}" werden geladen...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Training;
